module.exports = __webpack_public_path__ + "static/media/scroll4.4b0455a8.png";